import React, { useState } from 'react';
import Select, { IOption } from '../Select/Select';
import i18n from '../../i18n';
import { gray, black } from 'utils/style/colors';
import Textarea from '../Textarea';

export interface IConfig {
  key: string;
  label: string;
  value: string | boolean;
  type: 'text' | 'boolean';
  advanced?: boolean;
}

interface IConfigSelectorProps {
  availableConfigs: IConfig[];
  selectedConfigs: IConfig[];
  onAdd: (config: IConfig) => void;
  onRemove: (config: IConfig) => void;
  onValueChange?: (configKey: string, newValue: string | boolean) => void;
  disabled?: boolean;
  placeholder?: string;
  label?: string;
}

const ConfigSelector: React.FC<IConfigSelectorProps> = ({
  availableConfigs,
  selectedConfigs,
  onAdd,
  onRemove,
  onValueChange,
  disabled = false,
  placeholder = i18n.t('selectConfig', { ns: 'survey' }),
  label = i18n.t('availableConfigsToSelect', { ns: 'survey' }),
}) => {
  const [selectedValue, setSelectedValue] = useState<IOption[]>([]);

  const selectOptions = availableConfigs.map((config) => ({
    label: config.label,
    value: config.key,
  }));

  const handleConfigSelect = (options: IOption[]) => {
    if (options.length > 0) {
      const selectedKey = options[0].value;
      const config = availableConfigs.find((c) => c.key === selectedKey);
      if (config) {
        onAdd(config);
        setSelectedValue([]);
      }
    }
  };

  const handleValueChange = (configKey: string, newValue: string | boolean) => {
    if (onValueChange) {
      onValueChange(configKey, newValue);
    } else {
      const config = selectedConfigs.find((c) => c.key === configKey);
      if (config) {
        onRemove(config);
        onAdd({ ...config, value: newValue });
      }
    }
  };

  return (
    <div style={{ marginBottom: '20px' }} className="mt-2">
      <Select
        options={selectOptions}
        values={selectedValue}
        onChangeValues={handleConfigSelect}
        placeholder={placeholder}
        label={label}
        multiChoice={false}
        disabled={disabled}
      />

      {selectedConfigs.map((config) => (
        <div
          key={config.key}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
            padding: '8px 12px',
            margin: '4px 0',
            border: `1px solid ${gray}`,
            borderRadius: '4px',
            backgroundColor: `${gray}`,
          }}
        >
          <div className="flex items-center gap-2">
            <span
              style={{
                color: 'red',
                cursor: 'pointer',
                fontSize: '18px',
                fontWeight: 'bold',
              }}
              onClick={() => onRemove(config)}
            >
              ×
            </span>
            <span style={{ minWidth: '150px', color: black }}>
              {config.label}
            </span>
          </div>
          {config.type === 'boolean' ? (
            <Select
              options={[
                { label: 'بله', value: 'true' },
                { label: 'خیر', value: 'false' },
              ]}
              values={[
                {
                  label: config.value ? 'بله' : 'خیر',
                  value: config.value ? 'true' : 'false',
                },
              ]}
              onChangeValues={(options) => {
                if (options.length > 0) {
                  handleValueChange(config.key, options[0].value === 'true');
                }
              }}
              multiChoice={false}
              disabled={disabled}
              containerStyle={{ width: '70%' }}
            />
          ) : (
            <Textarea
              id={config.key}
              value={config.value as string}
              onChange={(e) => handleValueChange(config.key, e.target.value)}
              disabled={disabled}
              wrapperStyle={{ width: '70%' }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ConfigSelector;
